import request from "../index";

// 获取产品分类
export function productType(postdata){
    return request({
        method:"get",
        url:"/productType/web/tree/",
        data:postdata,
        isparams:true
    })
}

// 获取产品列表
export function productList(postdata){
  return request({
      method:"post",
      url:"/product/web/page",
      data:postdata
  })
}

// 获取产品详情
export function productDetail(postdata){
  return request({
      method:"get",
      url:"/product/web/info/",
      data:postdata,
      isparams:true
  })
}

// 获取产品类型详情banner
export function productTypeBanner(postdata){
  return request({
      method:"get",
      url:"/productType/info/web/",
      data:postdata,
      isparams:true
  })
}

// 提交留言信息
export function saveInfo(postdata){
  return request({
      method:"post",
      url:"/inquiry/web/submit",
      data:postdata
  })
}

// 按行业分类
export function industryType(postdata){
  return request({
    method:"get",
    url:"/projectType/web/tree/",
    data:postdata,
    isparams:true
  })
}

// 按场景分类
export function sceneType(postdata){
  return request({
    method:"get",
    url:"/sceneType/web/tree/",
    data:postdata,
    isparams:true
  })
}

// 获取场景分类详情
export function sceneList(postdata){
  return request({
    method:"get",
    url:"/sceneType/info/web/",
    data:postdata,
    isparams:true
  })
}

export function projectList(postdata){
  return request({
    method:"get",
    url:"/projectType/info/web/",
    data:postdata,
    isparams:true
  })
}


// WEBPACK FOOTER //
// ./src/api/modules/product.js